import { reloadPage } from "utils/reload-page.util";

const AUTH_KEYS_TO_PRESERVE = [
  "token",
  "expiration",
  "suno_comms_token",
  "suno_comms_refresh_token",
  "suno_comms_token_expiration"
];

const SESSION_KEYS_TO_PRESERVE = ["token", "suno-app-instance-id"];

export function clearNonAuthLocalStorage() {
  const savedAuthData: Record<string, string> = {};
  AUTH_KEYS_TO_PRESERVE.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) savedAuthData[key] = value;
  });

  localStorage.clear();

  Object.entries(savedAuthData).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
}

export function clearSessionStoragePreserveAuth() {
  const savedSessionData: Record<string, string> = {};
  SESSION_KEYS_TO_PRESERVE.forEach((key) => {
    const value = sessionStorage.getItem(key);
    if (value !== null) savedSessionData[key] = value;
  });

  sessionStorage.clear();

  Object.entries(savedSessionData).forEach(([key, value]) => {
    sessionStorage.setItem(key, value);
  });
}

export function clearIndexedDBDatabases() {
  const dbNames = [
    "medical-transcribes",
    "appointment-forms",
    "ReportSettingsDB"
  ];

  dbNames.forEach((name) => {
    try {
      indexedDB.deleteDatabase(name);
    } catch (error) {
      console.warn(`Failed to delete IndexedDB database "${name}":`, error);
    }
  });
}

export function clearAllStorageAndDatabases() {
  localStorage.clear();
  sessionStorage.clear();
  clearIndexedDBDatabases();
}

export function clearAppDataAndReload() {
  clearNonAuthLocalStorage();
  clearSessionStoragePreserveAuth();
  clearIndexedDBDatabases();
  // Cache-busted, not a plain reload: a plain reload can be served the same
  // stale (browser/CDN/proxy) index.html, so clearing local storage/IndexedDB
  // alone doesn't fix a stuck chunk-load error (SN-18813, same reasoning as
  // lazy-with-retry.util.ts's auto-recovery reload).
  reloadPage();
}
